import type { Collection } from 'state/utils/types';

import type { TabType, WorkspaceType } from '../model';

export type TabAction = { tabId: string };
export function isTabAction(val?: any): val is TabAction {
  return (val as TabAction | undefined)?.tabId !== undefined;
}
export enum TabLoadingStatus {
  NotLoaded = 'notLoaded',
  Loading = 'loading',
  Loaded = 'loaded',
  LoadingFailed = 'loading_failed',
  HasBeenCloned = 'hasBeenCloned',
}

export function isTabLoadable(status?: TabLoadingStatus): boolean {
  switch (status) {
    case 'loading':
    case 'loaded':
    case 'hasBeenCloned':
      return false;
    case undefined:
    case 'notLoaded':
      return true;
    default:
      return true as never;
  }
}

export interface WorkspaceTab {
  id: string;
  type: TabType;
  workspace: WorkspaceType;
  name?: string;
  count: number;
  color?: string;
  error?: string;
  traceId?: string;
  loadingStatus?: TabLoadingStatus;
  isBusy?: boolean; // tab in orange, previously spinner
  isFrozen?: boolean; // tab content will be disabled or readonly
  key?: string;
}

export type WorkspaceTabStateMap = Collection<Readonly<WorkspaceTab>>;

export const initialWorkspaceTabStateMap: WorkspaceTabStateMap = {};
